import store from '../store'

export default () => {
  const onSigninRequest = store.getState().getIn(['pluginSettings', 'onSigninRequest'])

  if (typeof(onSigninRequest) === 'function') onSigninRequest()
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/request_signin.js
 **/